import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    dataimexs: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_DATAINEX_SELECT_IDS (store, ids) {
      store.dataimexs.selectIds = ids
    },
    REMOVE_DATAINEX_SELECT_IDS (store, ids) {
      store.dataimexs.selectIds = store.dataimexs.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_DATAINEX_SELECT_ID (store, id) {
      store.dataimexs.selectId = id
    },
    SET_DATAINEX_FILTERS (store, filters) {
      store.dataimexs.filters = filters
    },
    SET_DATAINEX_PAGINATE (store, val) {
      store.dataimexs.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getDataimexs: (store, getters) => {
      return store.dataimexs.selectIds.map((id) => {
        return getters['entities/dataimexs/find'](id)
      })
    },
    getDataimexsFilters: (store, getters) => {
      return store.dataimexs.filters
    },
    getDataimexsPaginate: (store, getters) => {
      return store.dataimexs.paginate
    },
    getDataimex: (store, getters) => {
      return getters['entities/dataimexs/find'](store.dataimexs.selectId) || {}
    }
  },
  actions: {
    /*
    selectDataimexs
    */
    selectDataimexs ({commit, dispatch, getters, state}, filters) {
      return dispatch('getDataimexs', filters)
      .then((response) => {
        commit('SET_DATAINEX_FILTERS', filters)
        commit('SET_DATAINEX_PAGINATE', response)
        commit('SET_DATAINEX_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectDataimexs
    */
    refreshSelectDataimexs ({commit, dispatch, getters, state}) {
      return dispatch('selectDataimexs', getters.getDataimexsFilters)
    },
    /*
    selectDataimex
    */
    selectDataimex ({commit, dispatch, getters, state}, id) {
      return dispatch('getDataimexById', id)
      .then((response) => {
        commit('SET_DATAINEX_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getDataimexs
    */
    getDataimexs ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/dataimex`, {params: filters})
      .then((response) => {
        return dispatch('entities/dataimexs/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.dataimexs || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getDataimexById
    */
    getDataimexById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/dataimex/${id}`)
      .then((response) => {
        return dispatch('entities/dataimexs/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.dataimexs[0]
      })
    },
    /*
    importDataimex
    */
    importDataimex ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/dataimex/import/${data.entity}`, data)
      .then((response) => {
        return dispatch('entities/dataimexs/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.dataimexs[0]
      })
    },
    /*
    exportDataimex
    */
    exportDataimex ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/dataimex/export/${data.entity}`, data)
      .then((response) => {
        return dispatch('entities/dataimexs/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.dataimexs[0]
      })
    },
    /*
    deleteDataimex
    */
    deleteDataimex ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/dataimex/${id}`)
      .then((response) => {
        commit('REMOVE_DATAINEX_SELECT_IDS', [id])
        dispatch('entities/dataimexs/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Dataimex.js